export class CustomCursor {
  private cursor: HTMLDivElement;

  constructor() {
    this.cursor = document.createElement("div");
    this.cursor.className = "custom-cursor";
    document.body.appendChild(this.cursor);

    this.bindEvents();
  }

  private bindEvents() {
    window.addEventListener("mousemove", this.onMouseMove);
    window.addEventListener("mouseover", this.onMouseOver);
    window.addEventListener("mouseout", this.onMouseOut);
  }

  private onMouseMove = (e: MouseEvent) => {
    this.cursor.style.left = `${e.clientX}px`;
    this.cursor.style.top = `${e.clientY}px`;
  };

  private onMouseOver = (e: MouseEvent) => {
    const target = e.target as HTMLElement;

    if (this.isLink(target)) {
      this.cursor.classList.add("is-link");
    }
  };

  private onMouseOut = (e: MouseEvent) => {
    const target = e.target as HTMLElement;

    if (this.isLink(target)) {
      this.cursor.classList.remove("is-link");
    }
  };

  private isLink(el: HTMLElement): boolean {
    return !!el.closest("a, button, [role='button']");
  }
}
